import { Button } from "@/components/ui/button"
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { useNavigate } from "react-router-dom"

const benefitTypes = [
  "Subsidio de maternidad",
  "Prestaciones médico-farmacéuticas",
  "Subsidio de incapacidad temporal",
  "Prestaciones por invalidez",
  "Pensión de vejez",
  "Prestaciones de muerte y supervivencia",
  "Protección al empleo",
  "Subsidios familiares",
  "Servicios sociales",
]

export function Home() {
  const navigate = useNavigate()

  return (
    <main className="mx-auto flex min-h-screen w-full max-w-5xl flex-col gap-8 p-6 md:p-10">
      <header className="space-y-3">
        <p className="text-sm font-medium text-muted-foreground">Portal de Beneficios Digitales INSESO</p>
        <h1 className="text-3xl font-semibold tracking-tight">Portal de Información Pública</h1>
        <p className="text-muted-foreground">
          Navegue por los tipos de beneficios disponibles, luego regístrese o inicie sesión para iniciar su solicitud digital.
        </p>
      </header>

      <section className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
        {benefitTypes.map((benefit) => (
          <Card key={benefit}>
            <CardHeader>
              <CardTitle>{benefit}</CardTitle>
            </CardHeader>
            <CardContent className="text-sm text-muted-foreground">
              Consulta los requisitos y solicita este beneficio después de autenticarte.
            </CardContent>
          </Card>
        ))}
      </section>

      <section className="flex flex-wrap gap-3">
        <Button onClick={() => navigate("/register")}>Crear Cuenta</Button>
        <Button variant="outline" onClick={() => navigate("/login")}>
          Iniciar Sesión
        </Button>
      </section>
    </main>
  )
}
